export default __webpack_public_path__ + "static/media/logout.03145792.svg";